import React from 'react'
import Calendar from './Calendar'
import EventListContentByVehicle from './EventListContentByVehicle'
import Grid from '@material-ui/core/Grid'
import { Query } from 'react-apollo'
import {
  refreshToken
} from '../utils/token'
import {
  getUserInfo
} from '../utils/userInfo'
import {
  EVENT_CREATED_BY_VEHICLE,
  EVENT_OF_SELECTED_DAY_BY_VEHICLE,
  EVENT_TO_CHECK_OF_SELECTED_DAY_BY_VEHICLE,
  CHECKED_EVENT_OF_SELECTED_DAY_BY_VEHICLE,
  OFFENSE_OF_SELECTED_DAY_BY_VEHICLE,
  EVENT_OF_SELECTED_MONTH_BY_VEHICLE,
  EVENT_TO_CHECK_OF_SELECTED_MONTH_BY_VEHICLE,
  CHECKED_EVENT_OF_SELECTED_MONTH_BY_VEHICLE,
  OFFENSE_OF_SELECTED_MONTH_BY_VEHICLE,
  REFUEL_EVENT_BY_DATE,
  REFUEL_EVENT_DATE_BY_MONTH
} from '../query/event'
import moment from 'moment'
import momentTimezone from 'moment-timezone'
import CircularProgress from '@material-ui/core/CircularProgress'
import { omegaClient } from '../graphql/omegaClient'
moment.locale('fr')

let d = new Date()
d.setHours(0, 0, 0, 0)

class EventContentByVehicleComponent extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      selectedDay: props.events && props.events.length > 0 ? moment(new Date()).format('YYYY-MM-DD') : undefined,
      data: props.events,
      dateList: [],
      selectedMonth: d,
      loadingEvents: false
    }
  }

  componentDidMount () {
    // Fetch event dates for current month
    const month = this.state.selectedMonth
    const monthNumber = month.getMonth() + 1
    const yearNumber = month.getFullYear()

    if (this.props.trackableLabel) {
      this.refuelEventDateByMonth([this.props.trackableLabel], monthNumber.toString(), yearNumber.toString())
        .then((eventDates) => {
          const uniqueDateStrings = [...new Set(eventDates.map(eventDate => eventDate.date))]
          const dateList = uniqueDateStrings.map(dateStr => new Date(dateStr))
          this.setState({ dateList })
        })
        .catch((error) => {
          console.log('error fetching month dates', error)
        })
    }
  }

  componentWillReceiveProps (nextProps) {
    // Update data when events prop changes (from polling)
    // But only if we're viewing current day
    let formattedSelectedDay = moment(new Date(this.state.selectedDay)).format('MM/DD/YYYY')
    let formattedCurrentDay = moment(new Date()).format('MM/DD/YYYY')

    if (nextProps.events !== this.props.events && formattedSelectedDay === formattedCurrentDay) {
      this.setState({ data: nextProps.events })
    }

    // Fetch event dates when trackableLabel becomes available
    if (nextProps.trackableLabel !== this.props.trackableLabel && nextProps.trackableLabel) {
      const month = this.state.selectedMonth
      const monthNumber = month.getMonth() + 1
      const yearNumber = month.getFullYear()

      this.refuelEventDateByMonth([nextProps.trackableLabel], monthNumber.toString(), yearNumber.toString())
        .then((eventDates) => {
          const uniqueDateStrings = [...new Set(eventDates.map(eventDate => eventDate.date))]
          const dateList = uniqueDateStrings.map(dateStr => new Date(dateStr))
          this.setState({ dateList })
        })
        .catch((error) => {
          console.log('error fetching month dates', error)
        })
    }
  }

  // componentDidMount () {
  //   if (this.props.route === 'EventByVehicle' || this.props.route === 'CheckEventByVehicle') {
  //     this.props.subscribeToMore({
  //       document: EVENT_CREATED_BY_VEHICLE,
  //       variables: { occurred_at: new Date(), jsonFilter: { 'trb_imm': this.props.vehicleNumber } },
  //       updateQuery: (prev, { subscriptionData }) => {
  //         if (!subscriptionData.data || subscriptionData.data.events.length === 0) {
  //           return prev
  //         }
  //         const currentEventCreated = subscriptionData.data.events
  //         let events = [
  //           ...currentEventCreated,
  //           ...prev.events
  //         ]
  //         this.setState({
  //           data: events
  //         })
  //         return {
  //           events: events
  //         }
  //       }
  //     })
  //   }
  // }

  getDateInData (data) {
    let dateList = []
    data.forEach(function (element) {
      dateList.push(new Date(momentTimezone.utc(element.occurred_at).tz('Indian/Antananarivo')))
    })
    return dateList
  }

  getFormattedDateList (data) {
    let formattedDateList = []
    if (data) {
      data.forEach(function (element) {
        formattedDateList.push(momentTimezone.utc(element.occurred_at).tz('Indian/Antananarivo').format('MM/DD/YYYY'))
      })
    }
    return this.removeDuplicate(formattedDateList)
  }

  removeDuplicate (array) {
    let unique = {}
    array.forEach(function (i) {
      if (!unique[i]) {
        unique[i] = true
      }
    })
    return Object.keys(unique)
  }

  handleDayClick (day, selected) {
    const self = this
    var token = localStorage.getItem('token')
    let formattedDate = moment(day).format('YYYY-MM-DD')
    let formattedCurrentDay = moment(new Date()).format('MM/DD/YYYY')
    let formattedDayClicked = moment(day).format('MM/DD/YYYY')
    getUserInfo(token)
      .then(response => response.json())
      .then(function (result) {
        if (result.error && result.error.code === 401) {
          refreshToken(localStorage.getItem('refresh_token'))
        }
        self.setState({ selectedDay: formattedDate })

        // Fetch events for selected day if not current day
        if (formattedDayClicked !== formattedCurrentDay) {
          self.setState({ loadingEvents: true })
          self.refuelEventByDate([self.props.trackableLabel], formattedDate)
            .then((refuelEvents) => {
              self.setState({
                data: refuelEvents,
                loadingEvents: false
              })
            })
            .catch((error) => {
              console.log('error', error)
              self.setState({ loadingEvents: false })
            })
        } else {
          // Reset to current day data from props
          self.setState({ data: self.props.events })
        }
      })
      .catch((error) => {
        console.log('error: ', error)
      })
  }

  onMonthChange (month) {
    const self = this
    var token = localStorage.getItem('token')
    getUserInfo(token)
      .then(response => response.json())
      .then(function (result) {
        if (result.error && result.error.code === 401) {
          refreshToken(localStorage.getItem('refresh_token'))
        }

        self.setState({
          selectedMonth: month
        })
        // Fetch event dates for the selected month
        const monthNumber = month.getMonth() + 1 // JavaScript months are 0-indexed
        const yearNumber = month.getFullYear()
        self.refuelEventDateByMonth([self.props.trackableLabel], monthNumber.toString(), yearNumber.toString())
          .then((eventDates) => {
            // Get distinct dates and map to Date objects
            const uniqueDateStrings = [...new Set(eventDates.map(eventDate => eventDate.date))]
            const dateList = uniqueDateStrings.map(dateStr => new Date(dateStr))
            self.setState({
              dateList
            })
          })
          .catch((error) => {
            console.log('error fetching month dates', error)
          })
      })
      .catch((error) => {
        console.log('error: ', error)
      })
  }

  getEventQueryOfSelectedDay (route) {
    let query
    switch (route) {
      case 'EventByVehicle':
        query = EVENT_OF_SELECTED_DAY_BY_VEHICLE
        break
      case 'CheckEventByVehicle':
        query = EVENT_TO_CHECK_OF_SELECTED_DAY_BY_VEHICLE
        break
      case 'CheckedEventByVehicle':
        query = CHECKED_EVENT_OF_SELECTED_DAY_BY_VEHICLE
        break
      case 'OffenseByVehicle':
        query = OFFENSE_OF_SELECTED_DAY_BY_VEHICLE
        break
      default:
        query = EVENT_OF_SELECTED_DAY_BY_VEHICLE
    }
    return query
  }

  refuelEventByDate (trackableLabels, date) {
    return new Promise((resolve, reject) => {
      omegaClient
        .query({
          query: REFUEL_EVENT_BY_DATE,
          variables: { trackable_labels: trackableLabels, date: date },
          fetchPolicy: 'network-only'
        })
        .then((result) => {
          resolve(result.data.refuel_events_by_date)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  refuelEventDateByMonth (trackableLabels, month, year) {
    return new Promise((resolve, reject) => {
      omegaClient
        .query({
          query: REFUEL_EVENT_DATE_BY_MONTH,
          variables: { trackable_labels: trackableLabels, month: month, year: year },
          fetchPolicy: 'network-only'
        })
        .then((result) => {
          resolve(result.data.refuel_events_dates_by_month)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  renderEventListContent () {
    if (this.state.loadingEvents) {
      return <CircularProgress style={{ color: '#7ED321', marginTop: '50px' }} color='inherit' />
    }
    return (
      <EventListContentByVehicle
        route={this.props.route}
        data={this.state.data}
        keySearch={this.props.keySearch}
        trackableName={this.props.trackableName}
      />
    )
  }

  getEventQueryOfSelectedMonth (route) {
    let query
    switch (route) {
      case 'EventByVehicle':
        query = EVENT_OF_SELECTED_MONTH_BY_VEHICLE
        break
      case 'CheckEventByVehicle':
        query = EVENT_TO_CHECK_OF_SELECTED_MONTH_BY_VEHICLE
        break
      case 'CheckedEventByVehicle':
        query = CHECKED_EVENT_OF_SELECTED_MONTH_BY_VEHICLE
        break
      case 'OffenseByVehicle':
        query = OFFENSE_OF_SELECTED_MONTH_BY_VEHICLE
        break
      default:
        query = EVENT_OF_SELECTED_MONTH_BY_VEHICLE
    }
    return query
  }

  render () {
    var month = this.state.selectedMonth
    var startMonth = moment([month.getFullYear(), month.getMonth()]).toDate()
    var endMonth = moment([month.getFullYear(), month.getMonth()]).endOf('month').toDate()
    const self = this
    if (['CheckEventByVehicle', 'CheckedEventByVehicle', 'OffenseByVehicle'].includes(this.props.route)) {
      return null
    }
    // Convert selectedDay string to Date object for react-day-picker
    const selectedDayAsDate = this.state.selectedDay ? new Date(this.state.selectedDay) : undefined
    return (
      <div style={styles.root}>
        <Grid container spacing={24}>
          <Grid item xs={12} sm={12} md={8} lg={9} xl={10}>
            {self.renderEventListContent()}
          </Grid>
          <Grid item xs={12} sm={12} md={4} lg={3} xl={2}>
            <Calendar
              initialMonth={this.state.selectedMonth}
              onMonthChange={(month) => this.onMonthChange(month)}
              selectedDay={selectedDayAsDate}
              handleDayClick={(day, selected) => this.handleDayClick(day, selected)}
              dateList={this.state.dateList}
            />
          </Grid>
        </Grid>
      </div>
    )
  }
}

const styles = {
  root: {
    flexGrow: 1,
    marginLeft: '14px',
    marginBottom: '20px'
  }
}

export default EventContentByVehicleComponent
